var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.341.67a2.287 2.287 0 013.235 0l1.754 1.754a2.287 2.287 0 010 3.235L6.051 17.937a.633.633 0 01-.338.176l-4.97.877a.634.634 0 01-.733-.733l.877-4.97a.633.633 0 01.176-.338L13.34.669zm2.34.896a1.02 1.02 0 00-1.444 0l-.43.429 3.198 3.197.43-.43a1.02 1.02 0 000-1.442L15.68 1.566zm.429 4.522L12.912 2.89l-.566.567 3.197 3.197.567-.566zM14.648 7.55L11.45 4.352l-9.045 9.045 3.197 3.197 9.045-9.044zM4.295 17.077l-2.88.509.508-2.881 2.372 2.372z",
    fill: "#6373A4"
  })));
}

export default SvgEditPencil;